export const MaterialCoverageString = {
    orderPriority: " Order Priority",
    statusKits: " Status Of Kits",
    viewAllRecords: "View All Records"
}

export const InsightsAndTrendsString = {
    rmpmOrderwiseCoverage: "RM / PM Orderwise Coverage",
    ordersWithFullkitOHS: "Orders With Full Kit (On hand Stock)",
    ordersWithFullkitSIT: "Orders With Full Kit (incl. In Transit Inventory + In QC)",
    ordersWithFullkitOPO: "Orders With Full Kit (incl. In Open Orders)",
    ordersWithRMPM: "Orders With RM /PM Shortage"
}

export const ProductionInsightsAndTrendsString = {
    stplWithLimits: "Released WIP In Days - STPL With Limits",
    fullKitInDays: "Full Kit In Days",
    orderAtRisk: "Top 10 Reasons For Orders At Risk",
    trailDeptCount: "Trailing Department-Wise Count Of Orders",
    trailDeptMfg: "Trailing Department-Wise Balance To Manufacture",
    trailDeptDisp: "Trailing Department-Wise Balance To Dispatch",
}

export const Poogi = {
    otif: "OTIF % Trend",
    otNif: "OT & IF % Trend",
}

export const ManufacturingHub = {
    reasonHeading: "Major | Minor Reasons For OTIF Failure",
}